import { tsValidateArray, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { VariableTypes } from '../../_entity/variable/types.js';
export const Validator_ContextRule = {
    tagIds: tsValidateArray(tsValidateUniqueId),
    variableTypes: tsValidateArray(tsValidateValue([...VariableTypes]), false),
};
//# sourceMappingURL=validator.js.map